<template lang="pug">
.customer-block(v-loading="loading || saving")

  template(v-if="blocked !== null")
    .status
      el-tag(v-if="blocked" type="danger") Bloqueado
      el-tag(v-else type="success") Liberado

      el-popconfirm(
        v-if="blocked"
        title="Desbloquear este cliente? O acesso à conta é liberado em até 1 minuto."
        confirm-button-text="Desbloquear"
        cancel-button-text="Cancelar"
        width="260"
        popper-class="customer-block-popconfirm"
        @confirm="unblock"
      )
        el-button(slot="reference" size="small" type="primary" plain) Desbloquear cliente

      el-popconfirm(
        v-else
        title="Bloquear este cliente? O acesso à conta é bloqueado em até 1 minuto."
        confirm-button-text="Bloquear"
        cancel-button-text="Cancelar"
        width="260"
        popper-class="customer-block-popconfirm"
        @confirm="block"
      )
        el-button(slot="reference" size="small" type="danger" plain) Bloquear cliente

    p.hint Bloquear impede o cliente de usar a conta, mas não cancela assinaturas.

  p.hint(v-else-if="!loading") Falha ao carregar o status de bloqueio. Recarregue a página ou tente novamente mais tarde.

</template>
<script setup>
import { onMounted, ref } from 'vue'

import CustomerService from '@/services/CustomerService'
import { useMessage } from '@/utils/Message'

const props = defineProps({
  customerId: { type: Number, required: true },
})

const message = useMessage()

const loading = ref(true)
const saving = ref(false)

// null while unknown (not loaded yet or failed to load)
const blocked = ref(null)

const load = async () => {
  loading.value = true

  try {
    blocked.value = (await CustomerService.getBlockedStatus(props.customerId)).blocked
  } catch (e) {
    blocked.value = null
  } finally {
    loading.value = false
  }
}

const updateBlocked = async (request, successMessage, errorMessage) => {
  saving.value = true

  try {
    await request(props.customerId)
    message.success(successMessage)
  } catch (e) {
    message.error(errorMessage)
  } finally {
    saving.value = false
  }

  await load()
}

const block = () =>
  updateBlocked(CustomerService.blockCustomer, 'Cliente bloqueado.', 'Falha ao bloquear cliente.')

const unblock = () =>
  updateBlocked(CustomerService.unblockCustomer, 'Cliente desbloqueado.', 'Falha ao desbloquear cliente.')

onMounted(load)
</script>
<style lang="scss" scoped>
.customer-block {
  font-size: 14px;

  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .hint {
    margin-top: 8px;
    font-size: 12px;
    color: #8f8f8f;
    text-align: center;
  }
}
</style>
<style lang="scss">
// The popconfirm is appended to <body>, so the scoped block above can't reach it.
// Element sets word-break: break-all on popovers, which splits words mid-way.
.el-popover.customer-block-popconfirm {
  word-break: break-word;
}
</style>
